import { render, staticRenderFns } from "./CombinedSalaryDataTableRowSummary.vue?vue&type=template&id=481c33af&scoped=true"
import script from "./CombinedSalaryDataTableRowSummary.vue?vue&type=script&lang=js"
export * from "./CombinedSalaryDataTableRowSummary.vue?vue&type=script&lang=js"
import style0 from "./CombinedSalaryDataTableRowSummary.vue?vue&type=style&index=0&id=481c33af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c33af",
  null
  
)

export default component.exports